module.exports = __webpack_public_path__ + "static/media/image-3.cd0d3d4d.jpg";